import React, { ReactNode, useEffect, useState } from 'react';
import defaultTheme from '@src/theme';
import { JetThemeLight } from '@src/themes/JETTheme';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import useFMFeatureFlag from '@src/shared/hooks/use-fm-featureflag';
import { JETFM_FEATURE_LEGACY_THEME_TOGGLER } from '@src/shared/models';

interface componentProps {
  children: ReactNode;
}
const DynamicTheme = ({ children }: componentProps) => {
  const [activeTheme, setActiveTheme] = useState(defaultTheme);

  const is_legacy_theme_active = useFMFeatureFlag(JETFM_FEATURE_LEGACY_THEME_TOGGLER);

  const selectActiveTheme = () => {
    const isCurrentRouteProductOverViewPage = location.pathname === '/product-overview';
    const isCurrentRouteCourierOverViewPage = location.pathname === '/courier-overview';
    const isCurrentRouteNewOverViewPage = location.pathname === '/new-overview';
    const isCurrentRouteCouriersPage = location.pathname === '/couriers';
    const isCurrentRouteDeliveriesPage = location.pathname === '/deliveries';
    const isCurrentRouteDeliveryHistoryPage = location.pathname === '/delivery-history';
    const isCurrentRouteLegalTerms = location.pathname === '/terms-of-use';
    const isCurrentRoutePrivacy = location.pathname === '/privacy';
    /* const isCurrentNewDeliveryDashboard =
      location.pathname === '/delivery-dashboard'; */

    const activeTheme =
      is_legacy_theme_active &&
      !isCurrentRoutePrivacy &&
      !isCurrentRouteDeliveriesPage &&
      !isCurrentRouteProductOverViewPage &&
      !isCurrentRouteCourierOverViewPage &&
      !isCurrentRouteCouriersPage &&
      !isCurrentRouteDeliveryHistoryPage &&
      !isCurrentRouteLegalTerms &&
      !isCurrentRouteNewOverViewPage
        ? defaultTheme
        : JetThemeLight;
    setActiveTheme(activeTheme);
  };

  const onUrlChange = () => {
    selectActiveTheme();
  };

  useEffect(() => {
    let lastUrl = location.href;
    const observer: any = new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        onUrlChange();
      }
    }).observe(document, { subtree: true, childList: true });

    return () => observer?.disconnect();
  }, [is_legacy_theme_active]);

  useEffect(() => {
    selectActiveTheme();
  }, [is_legacy_theme_active]);

  return (
    <MuiThemeProvider theme={activeTheme}>
      <CssBaseline />
      {is_legacy_theme_active !== undefined && children}
    </MuiThemeProvider>
  );
};

export default DynamicTheme;
